import React, { useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { PropertyForm } from '../components/survey'
import useSurveyStore from '../stores/surveyStore'

export default function EditSurveyPage() {
  const { id } = useParams()
  const navigate = useNavigate()
  const { currentSurvey, loadSurvey, loading } = useSurveyStore()

  useEffect(() => {
    if (id) {
      loadSurvey(id)
    }
  }, [id, loadSurvey])

  if (loading || !currentSurvey) {
    return (
      <div className="max-w-2xl mx-auto">
        <div className="animate-pulse">
          <div className="h-8 bg-slate-200 rounded w-1/3 mb-4"></div>
          <div className="h-4 bg-slate-200 rounded w-1/2 mb-8"></div>
          <div className="space-y-4">
            <div className="h-12 bg-slate-200 rounded"></div>
            <div className="h-12 bg-slate-200 rounded"></div>
            <div className="h-12 bg-slate-200 rounded"></div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="max-w-2xl mx-auto">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-slate-900">Edit Survey Details</h1>
        <p className="text-slate-500 mt-1">
          Update the property information for this survey
        </p>
      </div>
      <PropertyForm
        initialData={currentSurvey}
        onSubmit={() => navigate(`/survey/${id}`)}
      />
    </div>
  )
}
